"use client";

"use client";

import { DIALOG, setDialog } from "@/components/app/dialogs/dialog-provider";
import { usePostContext } from "@/contexts/post-context";
import { useGetCurrentUserPostStats } from "@/hooks-api/use-get-current-user-post-stats";
import { ActivityModalType } from "@/utils/post-utils";
import { ReactionEmoji } from "@/utils/reactions-utils";

export const PostEmojiActivity = () => {
  const { post, repost, isPureRepost } = usePostContext();
  const activityPostHash = isPureRepost ? repost?.postHash : post?.postHash;

  const { totalReactionsCount, legacyLikesCount, reactionGroupCounts } =
    useGetCurrentUserPostStats(isPureRepost ? repost : post);

  if (!totalReactionsCount && !legacyLikesCount) return null;

  return (
    <div className="inline-flex">
      <div
        className="inline-flex cursor-pointer items-center gap-1 py-2"
        role="button"
        onClick={() => {
          if (!activityPostHash) {
            return;
          }

          setDialog(DIALOG.PostActivity, {
            open: true,
            params: {
              activity: ActivityModalType.reaction,
              postHash: activityPostHash,
            },
          });
        }}
      >
        {Object.entries(reactionGroupCounts).map(
          ([associationReactionValue, count]) =>
            count! > 0 ? (
              <div
                className="
                  flex size-6 items-center justify-center rounded-full bg-card
                  text-center text-sm
                "
                key={associationReactionValue}
              >
                {
                  ReactionEmoji[
                    associationReactionValue as keyof typeof ReactionEmoji
                  ]
                }
              </div>
            ) : null,
        )}
        {totalReactionsCount > 0 && legacyLikesCount > 0 && (
          <div className="rounded-full text-center text-xs text-muted">
            <span className="text-muted">+{legacyLikesCount}</span>
          </div>
        )}
      </div>
    </div>
  );
};
